<template>
  <el-table :data="items" style="width: 100%" size="small">
    <el-table-column prop="name" label="姓名"></el-table-column>
    <el-table-column prop="phone_number" label="手机号" min-width="100"></el-table-column>
    <el-table-column prop="role_names" label="角色" min-width="220"></el-table-column>
    <el-table-column prop="function_module_names" label="可见模块" min-width="200"> </el-table-column>
    <el-table-column prop="address" align="center" label="状态">
      <template slot-scope="scope">
        {{ scope.row.status == 1 ? '正常' : '禁用' }}
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center" min-width="150">
      <template slot-scope="scope">
        <el-button type="danger" size="mini" plain v-code="11103" @click.native="handleDeleteUser(scope.row, scope.$index)" v-if="scope.row.status == 0">删除</el-button>
        <el-popconfirm v-code="11103" :title="`确认重置密码为：88888888 吗？`" @confirm="handleResetPassword(scope.row.id)">
          <el-button slot="reference" type="warning" class="mr-10" size="mini">重置密码</el-button>
        </el-popconfirm>
        <el-button type="primary" size="mini" plain v-code="11103" @click.native="handleUpdateUser(scope.row, scope.$index)">{{ scope.row.status == 1 ? '禁用' : '启用' }}</el-button>
        <el-button type="primary" size="mini" plain @click="$router.push('/users/' + scope.row.id + '/edit')" v-code="11102">编辑</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { userUpdateStatus, userDelete, resetUserPassword } from '@/service/getData'

export default {
  props: {
    items: null,
  },
  methods: {
    handleUpdateUser(item, index) {
      let that = this
      let id = item.id
      id = id.toString()
      that.$dialog.confirm(`确认${item.status == 1 ? '禁用' : '启用'}吗`).then(function(dialog) {
        userUpdateStatus({
          id: id,
        }).then((res) => {
          if (res.status == 0) {
            that.items[index].status = res.data.status
          }
        })
      })
    },

    async handleResetPassword(id) {
      let res = await resetUserPassword({ id: id.toString() })
      if (res.code == 0) {
        this.$message({
          message: `密码重置成功！`,
          type: 'success',
          center: true,
        })
      }
    },

    handleDeleteUser(item, index) {
      let that = this
      let id = item.id
      id = id.toString()
      that.$dialog.confirm(`确认删除吗`).then(function(dialog) {
        userDelete(id).then((res) => {
          if (res.status == 0) {
            that.items.splice(index, 1)
          }
        })
      })
    },
  },
}
</script>
